<app-modal *ngIf="vo$ | async; let vo">
	<div modal-body class="app-connector-action-popup">
		<div class="app-connector-action-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span i18n="@@connector.action.popup.concernedElement">
					concerned Element
				</span>
				<span class="app-connector-action-popup__element-label">
					{{ vo.element }}
				</span>
			</ng-container>
			<ng-container *ngIf="vo.isMultipleElement">
				<span i18n="@@connector.action.popup.concernedElements">
					concerned Elements
				</span>
				<div class="app-connector-action-popup__element-label">
					{{ vo.connectorId.length }}
					<span i18n="@@connector.action.popup.connectors">connectors</span>
				</div>
			</ng-container>
		</div>
		<ng-container [ngSwitch]="vo.action">
			<div
				*ngSwitchCase="ConnectorAction.Delete"
				class="app-connector-action-popup__delete">
				<span
					*ngIf="vo.isMultipleElement"
					class="app-connector-action-popup__description"
					i18n="@@connector.action.popup.delete.multiple.description">
					deletion request
				</span>
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-connector-action-popup__description"
					i18n="@@connector.action.popup.delete.description">
					deletion request
				</span>

				<div class="app-connector-action-popup__delete-info">
					<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
					<span
						*ngIf="vo.isMultipleElement"
						class="app-connector-action-popup__message"
						i18n="@@connector.action.popup.delete.multiple.info">
						deletion info
					</span>
					<span
						*ngIf="!vo.isMultipleElement"
						class="app-connector-action-popup__message"
						i18n="@@connector.action.popup.delete.info">
						deletion info
					</span>
				</div>
				<div class="app-connector-action-popup__checkbox">
					<mat-checkbox
						id="{{ cmpId }}-confirm-checkbox"
						color="primary"
						[(ngModel)]="confirmDeletion">
							<span i18n="@@connector.action.popup.delete.confirm">confirm delete</span>
					</mat-checkbox>
				</div>
			</div>
		</ng-container>
	</div>

	<div modal-footer class="app-connector-action-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="ConnectorAction.Delete"
				id="{{ cmpId }}-delete-btn"
				class="app-connector-action-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirmDeletion"
				(click)="confirmAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
				<span i18n="@@connector.action.popup.delete.btn">delete</span>
			</button>
		</ng-container>
	</div>
</app-modal>
